<template>
  <global-modal :modelValue="isActive" :title="$route.meta.subtitle" @modalHandler="getData">
    <template #body>
      <div class="main-modal">
        <form @submit.prevent="submitHandler">
          <div class="form-group-modal">
            <label for="selectType">Classification</label>
            <select v-model="selectedClassification" required>
              <option disabled value="">--Please select--</option>
              <option v-for="(item, index) in itemAvailmentCategory" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="form-group-modal">
            <label for="selectType">Select Type</label>
            <select id="selectType" v-model="selectType" required @change="accountTypeItems()">
              <option value="" disabled selected>Select Type</option>
              <option value="AccountType">By Account Type</option>
              <option value="Company">By Company</option>
            </select>
          </div>
          <div class="form-group-modal" v-if="selectType === 'Company'">
            <label for="company">Company</label>
            <input id="company" type="text" v-model="company" required placeholder="Search Company..." @input="getCompanies(company)" />
            <div class="autofill">
              <ul v-if="itemCompanies && company">
                <li class="filter-company" v-for="(item, index) in itemCompanies" :key="index" @click="selectedHandler(item.Companies)">
                  {{ item.Companies }}
                </li>
              </ul>
            </div>
          </div>
          <div v-else class="form-group-modal">
            <label for="accountType">Account Type</label>
            <select id="accountType" v-model="selectedCategory" @change="premiumItems()" required>
              <option v-for="items in itemCategory" :key="items.id" :value="items">
                {{ items.categoryName }}
              </option>
            </select>
          </div>

          <div v-if="selectType !== 'Company'" class="form-group-modal">
            <label for="selectPremium">Select Premium</label>
            <select id="selectPremium" @change="selectPremiumHandler" required>
              <option value="" disabled>-- Select Premium --</option>
              <option v-for="item in itemPremium" :key="item.value" :value="item.value">
                {{ item.premium }}
              </option>
            </select>
          </div>
          <div class="form-group-modal-grid">
            <label for="frequency">Frequency</label>
            <select id="frequency" v-model="selectedFrequency" @change="frequencyHandler()" required>
              <option disabled value="">--Please select--</option>
              <option v-for="item in itemFrequency" :key="item.value" :value="item.value">
                {{ item.description }}
              </option>
            </select>
          </div>
          <div class="form-group-modal-grid" v-if="selectedFrequency === 'RD' ? true : false">
            <label for="dateFrom">Range Date</label>
            <input id="dateFrom" type="date" v-model="dateFrom" required />
            <input type="date" v-model="dateTo" required />
          </div>
          <div class="form-group-modal">
            <label for="reportType">Type of Report</label>
            <select id="reportType">
              <option v-for="(item, index) in itemReportType" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
          </div>
          <div class="form-group-modal input-field loading-container">
            <global-loading v-if="isLoading" />
            <input type="submit" class="btn-submit gradient" :value="!isLoading ? 'Generate' : ''" />
          </div>
        </form>
      </div>
    </template>
  </global-modal>
</template>
<script>
import UsedFrequencyUtils from "@/utils/frequency.js";
import { computed, inject, onMounted, reactive, ref, toRefs } from "vue";
export default {
  props: {
    isModal: Boolean,
  },
  setup(props, { emit }) {
    const axios = inject("$axios");
    const { selectedFrequency, dateFrom, dateTo, frequencyHandler } = UsedFrequencyUtils();
    const formData = reactive({
      company: null,
      frequency: null,
      dateFrom: null,
      dateTo: null,
    });
    const itemFrequency = ref([
      { description: "Last Month", value: "1" },
      { description: "Last 3 Months", value: "3" },
      { description: "Last 6 Months", value: "6" },
      { description: "Last 12 Months", value: "12" },
      { description: "Year to Date", value: "YTD" },
      { description: "Range Date", value: "RD" },
    ]);
    const isLoading = ref(false);
    const itemReportType = ref(["Regular UR"]);
    const itemCompanies = ref([]);
    const isActive = computed(() => props.isModal);
    const selectType = ref("Company");
    const selectedCategory = ref();
    const itemCategory = ref([]);
    const getData = (val) => {
      emit("updateModal", val);
    };
    const itemPremium = ref([]);
    const selectPremium = ref("");
    const itemAvailmentCategory = ref(["with special accommodation", "without special accommodation"]);
    const selectedClassification = ref("with special accommodation");
    onMounted(async () => {
      await accountTypeItems();
    });

    const getCompanies = async (company) => {
      try {
        const { data } = await axios.get(`/company`, { params: { name: company } });
        itemCompanies.value = data;
      } catch (error) {
        console.error("Error fetching transactions:", error);
      }
    };

    const selectedHandler = (val) => {
      formData.company = val;
      itemCompanies.value = [];
    };

    const submitHandler = async () => {
      formData.frequency = selectedFrequency.value;
      formData.dateFrom = dateFrom.value;
      formData.dateTo = dateTo.value;

      isLoading.value = true;

      if (selectType.value === "Company" && selectedClassification.value === "with special accommodation") {
        try {
          const { data } = await axios.get(`/companyur/withspecialaccom`, {
            params: {
              companyname: formData.company,
              dateFrom: formData.dateFrom,
              dateTo: formData.dateTo,
            },
          });

          if (data) {
            isLoading.value = false;
            let details = {
              companyname: formData.company,
              dateFrom: formData.dateFrom,
              dateTo: formData.dateTo,
              status: data.status,
              remark: "With Special Accommodation",
            };
            emit("getDataResult", data, details);
            emit("updateModal", false);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        } finally {
          isLoading.value = false;
        }
      }

      if (selectType.value === "Company" && selectedClassification.value === "without special accommodation") {
        try {
          const { data } = await axios.get(`/companyur/withoutspecialaccom`, {
            params: {
              companyname: formData.company,
              dateFrom: formData.dateFrom,
              dateTo: formData.dateTo,
            },
          });

          if (data) {
            isLoading.value = false;
            let details = {
              companyname: formData.company,
              dateFrom: formData.dateFrom,
              dateTo: formData.dateTo,
              status: data.status,
              remark: "Without Special Accommodation",
            };
            emit("getDataResult", data, details);
            emit("updateModal", false);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        } finally {
          isLoading.value = false;
        }
      }
      if (selectType.value === "AccountType") {
        if (!selectPremium.value) {
          console.error("Premium is required");
          isLoading.value = false;
          return;
        }
        try {
          const { data } = await axios.get(`/companyur/accounttype`, {
            params: {
              accounttype: selectedCategory.value?.categoryName,
              premium: selectPremium.value,
              dateFrom: formData.dateFrom,
              dateTo: formData.dateTo,
              specialAccom: selectedClassification.value === "with special accommodation" ? 1 : 0,
            },
          });

          if (data) {
            isLoading.value = false;
            let details = {
              companyname: `${selectedCategory.value?.categoryName} - ${selectPremium.value}`,
              dateFrom: formData.dateFrom,
              dateTo: formData.dateTo,
              status: data.status,
            };
            emit("getDataResult", data, details);
            emit("updateModal", false);
          }
        } catch (error) {
          console.error("Error fetching transactions:", error);
        } finally {
          isLoading.value = false;
        }
      }
    };

    const accountTypeItems = async () => {
      try {
        const response = await axios.get("/accounttypes");
        itemCategory.value = response.data.map((item, index) => ({
          id: index + 1,
          categoryName: item.description,
        }));
      } catch (error) {
        console.error("Failed to fetch account types:", error);
      }
    };

    const premiumItems = async () => {
      //selectPremium.value = ""; // clear stale selection from the previous category
      if (!selectedCategory.value) return;
      try {
        const response = await axios.get(`/account/premium`, {
          params: { name: selectedCategory.value.categoryName },
        });
        itemPremium.value = response.data;
      } catch (error) {
        console.error("Failed to fetch premium options:", error);
      }
    };

    const selectPremiumHandler = (event) => {
      selectPremium.value = event.target.value;
      console.log("selectPremiumHandler fired, selectPremium:", selectPremium.value);
    };

    return {
      ...toRefs(formData),
      selectedFrequency,
      dateFrom,
      dateTo,
      itemFrequency,
      itemReportType,
      isActive,
      getData,
      submitHandler,
      frequencyHandler,
      getCompanies,
      itemCompanies,
      selectedHandler,
      isLoading,
      selectType,
      accountTypeItems,
      itemCategory,
      premiumItems,
      itemPremium,
      selectedCategory,
      selectPremium,
      selectPremiumHandler,
      itemAvailmentCategory,
      selectedClassification,
    };
  },
};
</script>
<style scoped>
.autofill {
  position: relative;
}
ul {
  box-shadow: rgba(14, 63, 126, 0.04) 0px 0px 0px 1px, rgba(42, 51, 69, 0.04) 0px 1px 1px -0.5px, rgba(42, 51, 70, 0.04) 0px 3px 3px -1.5px, rgba(42, 51, 70, 0.04) 0px 6px 6px -3px,
    rgba(14, 63, 126, 0.04) 0px 12px 12px -6px, rgba(14, 63, 126, 0.04) 0px 24px 24px -12px;
  background-color: var(--light-color);
  border-radius: 4px;
  position: absolute;
  width: 545px;
  max-height: 285px;
  overflow-y: auto;
  z-index: 1000;
  left: 138px;
}
.filter-company {
  font-size: 15px;
  line-height: 22px;
  padding: 3px 8px;
  color: var(--font-color-four);
}
.filter-company:hover {
  background-color: var(--primary-gradient);
  color: var(--light-color);
}
.form-group-modal input[type="submit"] {
  color: var(--light-color);
  margin-top: 0px;
  height: 44px;
}
.loading-container {
  margin: 20px 0px;
}
@media only screen and (min-width: 320px) and (max-width: 440px) {
  ul {
    max-width: 100%;
    left: 0px;
  }
}
</style>
